import { useState } from "react";
import { formatUTCDateDash } from "@demandproai/shared";
import { FaEnvelope } from "react-icons/fa";
import { RenderIf, CaseActionControls } from "../index";
import CaseDetailsCell from "./CaseDetailsCell";
import CaseStatusCell from "./CaseStatusCell";
import DownloadOptions from "../../pages/admin/cases/component/DownloadOptions";
import VersionHistoryModal from "../../pages/admin/cases/component/VersionHistoryModal";
import useResultProgress from "../customHook/useResultProgress";
import { useNotificationContext } from "../../contexts/NotificationContext";
import { caseListRowClasses } from "../common/caseListClasses";
import { buildCaseReviewMessage } from "../../utils/easyModeCaseList";
import TableRowDivider from "../common/TableRowDivider";
import ClientNameCell from "../common/ClientNameCell";
import DefendantNameCell from "../common/DefendantNameCell";

const CaseTableRow = ({
    caseData,
    setCaseIdToDelete,
    openCaseId,
    handleToggle,
    handleCloseBox,
    getCases
}) => {
    const { unreadCaseIds } = useNotificationContext();

    const [isVersionHistoryOpen, setIsVersionHistoryOpen] = useState(false);

    const {
        isDemandSuccessful,
        isDemandFailed,
        isDemandDraft,
        requestCreatedAt
    } = useResultProgress(caseData.createRequests, caseData.isDraftCase);

    const reviewMessage = buildCaseReviewMessage({ gapReport: caseData.virtualUserGapReport });

    return (
        <>
            <tr className={caseListRowClasses}>
                <CaseDetailsCell caseData={caseData} />

                <td>
                    {unreadCaseIds.has(caseData._id) && (
                        <FaEnvelope className="text-primary" />
                    )}
                </td>
                <td>
                    <ClientNameCell caseData={caseData} />
                </td>
                <td>
                    <DefendantNameCell caseData={caseData} />
                </td>
                <td> {formatUTCDateDash(caseData?.updatedOn)} </td>
                <CaseStatusCell
                    isSuccessful={isDemandSuccessful}
                    updateTime={requestCreatedAt}
                    isFailed={isDemandFailed}
                    isDraft={isDemandDraft}
                    statusMessage={reviewMessage}
                />

                <td className="w-action-column min-w-action-column">
                    <CaseActionControls
                        caseData={caseData}
                        setCaseIdToDelete={setCaseIdToDelete}
                        onToggle={() => handleToggle(caseData._id)}
                    />
                    <RenderIf shouldRender={openCaseId === caseData._id}>
                        <DownloadOptions
                            caseData={caseData}
                            onClose={handleCloseBox}
                            onDownloadComplete={getCases}
                            onOpenVersionHistory={() => { handleCloseBox(); setIsVersionHistoryOpen(true); }}
                        />
                    </RenderIf>
                    <VersionHistoryModal
                        isOpen={isVersionHistoryOpen}
                        onClose={() => setIsVersionHistoryOpen(false)}
                        caseData={caseData}
                        onDownloadComplete={getCases}
                    />
                </td>
            </tr>
            <TableRowDivider colSpan={7} />
        </>
    );
};

export default CaseTableRow;
